import { useEffect, useRef } from "react";
import { io, Socket, ManagerOptions, SocketOptions } from "socket.io-client";

type UseSocketOptions = Partial<ManagerOptions & SocketOptions>;

export default function useSocket(url: string, options?: UseSocketOptions): [Socket] {
  const socketRef = useRef<Socket>();

  if (!socketRef.current) {
    socketRef.current = io(url, {
      autoConnect: options?.autoConnect ?? true,
      ...options,
    });
  }

  useEffect(() => {
    return () => {
      socketRef.current?.disconnect();
    };
  }, []);

  return [socketRef.current];
}
